import {Component, Input, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";
import {ActivatedRoute} from "@angular/router";
import * as _ from "lodash";
import {IMarketingPage} from "../marketing-page.models";
import {MarketingPageService} from "../marketing-page.service";
import {Constants} from "../../constants";
import {MarketingPageFactoryService} from "../marketing-page-factory.service";
import {BaseComponent} from "../../base.component";

@Component({
    selector: 'page-embed',
    templateUrl: './page-embed.component.html',
    standalone: false
})
export class PageEmbedComponent extends BaseComponent implements OnInit {

    @ViewChild('dynamicPage', {read: ViewContainerRef}) viewContainerRef: ViewContainerRef;

    @Input() marketingPageId: string;
    @Input() marketingPageInput: IMarketingPage;
    marketingPage: IMarketingPage = {modules: []} as IMarketingPage;
    readonly pageType: string = Constants.MARKETING_PAGE_TYPE_EMBED;

    constructor(loggerService: LoggerService,
                userService: UserService,
                private route: ActivatedRoute,
                private marketingPageFactoryService: MarketingPageFactoryService,
                private marketingPageService: MarketingPageService) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.getCustomerData().then(() => { // keep this for digest cycle error hack
            this.initMarketingPage();
        });
    }

    initMarketingPage() {
        if (this.marketingPageInput) {
            this.setPageData(this.marketingPageInput);
        } else {
            if (!this.marketingPageId) {
                this.marketingPageId = this.route.snapshot.paramMap.get("uniqueId");
            }
            this.marketingPageService.getPage(this.marketingPageId, this.pageType).subscribe((page: IMarketingPage) => this.setPageData(page));
        }
    }

    setPageData(page: IMarketingPage) {
        this.marketingPage = page;
        if (!!this.marketingPage && !_.isEmpty(this.marketingPage.modules)) {
            this.marketingPageId = this.marketingPage.url;
            this.loadComponents();
        }
    }

    loadComponents() {
        _.forEach(this.marketingPage.modules, (module: any, index: number) => {
            module.marketingPageId = this.marketingPageId;
            switch (module.type.toUpperCase()) {
                case Constants.MARKETING_PAGE_HERO: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.heroComponent);
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    break;
                }
                case Constants.MARKETING_PAGE_CHECKERBOARD: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.checkerboardComponent);
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    break;
                }
                case Constants.MARKETING_PAGE_GALLERY: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.galleryComponent);
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    break;
                }
                case Constants.MARKETING_PAGE_VIDEO: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.videoComponent);
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    break;
                }
                case Constants.MARKETING_PAGE_FAQ: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.faqComponent);
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    break;
                }
                case Constants.MARKETING_PAGE_DUO_TONE: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.duoToneComponent);
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    break;
                }
                case Constants.MARKETING_PAGE_HORIZONTAL_CARD: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.horizontalCardComponent);
                    const nextComponent = this.marketingPage.modules[index+1];
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    if (!!nextComponent && nextComponent.type === Constants.MARKETING_PAGE_GALLERY_CARDS) {
                        componentRef.instance.componentData.componentStyle = 'slim-bottom';
                    }
                    break;
                }
                case Constants.MARKETING_PAGE_GALLERY_CARDS: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.galleryCardsComponent);
                    const previousComponent = this.marketingPage.modules[index-1];
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    if (!!previousComponent && previousComponent.type === Constants.MARKETING_PAGE_HORIZONTAL_CARD) {
                        componentRef.instance.componentData.componentStyle = 'slim-top';
                    }
                    break;
                }
                case Constants.MARKETING_PAGE_PLACEHOLDER: {
                    const componentName = module.name;
                    const Component = this.marketingPageService.getPlaceholderComponent(componentName);
                    if (Component) {
                        const componentRef = this.viewContainerRef.createComponent<any>(Component);
                        componentRef.instance.componentData = module;
                        componentRef.instance.pageUrl = this.marketingPage.url;
                        componentRef.instance.useLocaleOverride = true;
                    } else {
                        console.error(`No component factory found for ${componentName}`);
                    }
                    break;
                }
            }
        });
    }

}
